import { api } from './index';

import type { Note, NoteOwnerType } from '@/types';

export interface NotesResponse {
  items: Note[];
  pages: number;
  total: number;
}

export interface GetNotesParams {
  limit?: number;
  owneableId: string;
  page?: number;
  owneableType?: NoteOwnerType;
}

export const noteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createNote: builder.mutation<Note, Partial<Note>>({
      invalidatesTags: ['Note'],
      query: (note) => ({
        data: { note },
        method: 'POST',
        url: '/notes',
      }),
    }),
    deleteNote: builder.mutation<void, Partial<Note>>({
      invalidatesTags: (_result, _error, note) => [
        { id: note.id, type: 'Note' },
        'Note',
      ],
      query: (note) => ({
        method: 'DELETE',
        url: `/notes/${note.id}`,
      }),
    }),
    getNotes: builder.query<NotesResponse, GetNotesParams>({
      providesTags: ['Note'],
      query: ({ limit = 10, owneableId, page = 1, owneableType }) => ({
        method: 'GET',
        url: `notes?owneable_id=${owneableId}&page=${page}&limit=${limit}${
          owneableType ? `&owneable_type=${owneableType}` : ''
        }`,
      }),
    }),
    updateNote: builder.mutation<Note, Partial<Note>>({
      invalidatesTags: (_result, _error, note) => [
        { id: note.id, type: 'Note' },
        'Note',
      ],
      query: (note) => ({
        data: { note },
        method: 'PUT',
        url: `/notes/${note.id}`,
      }),
    }),
  }),
});

export const {
  useCreateNoteMutation,
  useDeleteNoteMutation,
  useGetNotesQuery,
  useUpdateNoteMutation,
} = noteApi;
